/*
 * @Description: 一周数字品牌价值走势
 * @Author: yy
 * @Date: 2019-05-31 14:47:28
 * @LastEditors: yy
 * @LastEditTime: 2019-09-24 15:29:52
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
// @ts-ignore
import s from './p5.css';

import ExportHeadTitle from '../../../components/ExportHeadTitle'
import ExportDes from '../../../components/ExportDes'
import ExportFootDes from '../../../components/ExportFootDes'
import ExportEcharts from '../../../components/ExportEcharts'

import {getReportDB} from '../../../controller';
import {valueTrend} from '../../../chart';

import { getSessionQuery, toThousands } from '../../../utils';
import moment from 'moment';
import { buttomDate } from '../exportPDFConfig';

class P5 extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      query: {
        brandName: '',
        startDate: '',
        statisDate: ''
      },
      summary: {
        maxDB: '',
        maxDate: '',
        minDB: '',
        minDate: '',
        sort: ''
      },
      chart: {}
    };

    this.getData = this.getData.bind(this);
  }

  getQuery () {
    const query = getSessionQuery('query');

    const result = {
      brandName: query.brand,
      startDate: query.beginTime,
      statisDate: query.endTime
    }
    if (query.isCustom === '1') {
      result.areaIndustry = query.industry
      result.competingBrands = query.competingGoods.map(item => item.value).join(',')
    }
    return result
  }

  componentDidMount () {
    this.getData();
  }

  getData () {
    const query = this.getQuery();

    getReportDB(query)
      .then(data => {
        this.setState({
          query: query,
          summary: data.summary,
          chart: valueTrend(data, query)
        })
      })
  }

  render() {
    const {query, summary} = this.state;
    return (
      <div className={s.container}>
        <ExportHeadTitle>一周数字品牌价值走势</ExportHeadTitle>

        <div>
          <ExportDes>
            本周，{query.brandName}DB总值最高为{moment(summary.maxDate).format(buttomDate)}，达到{toThousands(summary.maxDB)}<em>DB</em>；
            最低为{moment(summary.minDate).format(buttomDate)}，为{toThousands(summary.minDB)}<em>DB</em>。
          </ExportDes>
          <ExportDes>{query.brandName}在四大社交媒体平台上的数字价值和受关注程度依次为：{summary.sort}。</ExportDes>
        </div>

        <div className={s.echartWrapper}>
          <ExportEcharts option={this.state.chart}></ExportEcharts>
        </div>

        <ExportFootDes
          brandName={query.brandName}
          beginTime={query.startDate}
          endTime={query.statisDate}>
        </ExportFootDes>
      </div>
    );
  }
}

export default withStyles(s)(P5);



// WEBPACK FOOTER //
// src/routes/exportPDF/p5/p5.js